// Module
var code = "<div class=\"loaderFocused\">\r\n        <div class=\"loaderContainer\">\r\n            <div class=\"loader curveDetailsLoader\"></div>\r\n            <h2 class=\"loaderText\" data-bind=\"text: loaderText\"></h2>\r\n        </div>\r\n</div>\r\n";
// Exports
module.exports = code;